<template>
	<div class="trivia-result">
		<div class="money-reward" v-if="correct">
			+{{ amount | currency }}
		</div>
		<SpinTracker :addedSpins="amount" v-else />
	</div>
</template>

<script>
import SpinTracker from "@/components/game/header/SpinTracker";

export default {
	name: 'TriviaResult',
	components: {
		SpinTracker,
	},
	props: {
		amount: {
			type: Number,
			required: true,
		},
		correct: {
			type: Boolean,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.spin-tracker {
		position: relative;
		box-shadow: $big-bummer-1 0 0 30px;
		margin: 20px 0;
	}
</style>
